import React from "react";
import { makeStyles, Grid, Typography, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

function PartnersShare({ partners }) {
  const classes = useStyles();
  return (
    <Grid container spacing={2} className="mb-4">
      {partners.map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item.wallet}>
          <Paper elevation={0} className={classes.paperContainer}>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <Typography variant="body2" className="fw-bolder">
                Wallet:
              </Typography>
              <Typography variant="caption" className="word-break">{item.wallet}</Typography>
            </div>

            <div className="d-flex align-items-center justify-content-between flex-wrap mt-2">
              <Typography variant="body2" className="fw-bolder">
                Share:
              </Typography>
              <Typography variant="caption">{item.share}</Typography>
            </div>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

export default PartnersShare;
